import React, {useState} from 'react';
import {
    HeroContainer,
    HeroBg,
    VideoBg,
    HeroContent,
    HeroH1,
    HeroP,
    HeroBtnWrapper,
    ArrowForward,
    ArrowRight,
    ButtonElement
} from './HeroElements';
import Video from '../../videos/video.mp4';

const HeroSection = () => {
    const [hover, setHover] = useState(false);

    const onHover = () => {
        setHover(!hover);
    }

    return (
        <HeroContainer id="home">
            <HeroBg>
                <VideoBg autoPlay loop muted src={Video} type='video/mp4' />
            </HeroBg>
            <HeroContent>
                <HeroH1>Recruitment Redefined</HeroH1>
                <HeroP>
                    Setting The Stage For A Successful Today And Tomorrow 
                </HeroP>
                <HeroBtnWrapper>
                    <ButtonElement
                        to='about' 
                        onMouseEnter={onHover} 
                        onMouseLeave={onHover}
                        dark='true'
                        primary='true' 
                        smooth={true} 
                        duration={500} 
                        spy={true} 
                        exact='true' 
                        offset={-80}>
                        Learn more {hover ? <ArrowForward /> : <ArrowRight />}
                    </ButtonElement>
                </HeroBtnWrapper>
            </HeroContent>
        </HeroContainer>
    )
}

export default HeroSection;
